import {createSlice} from '@reduxjs/toolkit'
import {getShippingLabelTypes} from '../labelTypes'

export const setShippingLabelTypes = (carrierType: string) => (dispatch: any) => {
  const labelTypes = getShippingLabelTypes(carrierType)
  dispatch(setLabelTypes(labelTypes))
}

const shippingLabelSlice = createSlice({
  name: 'shippingLabel',
  initialState: {
    labelImageTypes: [],
    labelTypes: [],
    thermalLabelTypes: [],
  },
  reducers: {
    setLabelTypes: (state, action) => {
      const {labelTypes, imageTypes, thermalLabelTypes}: any = action.payload
      state.labelTypes = labelTypes
      state.labelImageTypes = imageTypes
      state.thermalLabelTypes = thermalLabelTypes
    },
  },
})

export default shippingLabelSlice.reducer
export const {setLabelTypes} = shippingLabelSlice.actions
